import { type SVGProps } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g filter="url(#filter0_d_14263_67042)">
      <path
        d="M4.25 16C4.25 7.16344 11.4134 0 20.25 0
          C29.0866 0 36.25 7.16344 36.25 16
          C36.25 24.8366 29.0866 32 20.25 32
          C11.4134 32 4.25 24.8366 4.25 16Z"
        fill="#EFF2F4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.9957 9.58585C17.7767 8.8048 19.0431 8.8048
          19.8241 9.58585L25.5312 15.293C25.9218 15.6835 
          25.9218 16.3166 25.5312 16.7072L19.8241 22.4143C19.0431
          23.1953 17.7767 23.1953 16.9957 22.4143C16.2146 21.6332
          16.2146 20.3669 16.9957 19.5858L20.5815 16.0001L16.9957
          12.4143C16.2146 11.6332 16.2146 10.3669 16.9957 9.58585Z"
        fill="#1A212C"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_14263_67042"
        x="0.25"
        y="0"
        width="40"
        height="40"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.0745098 0 0 0 0 0 0 0 0 0 0.192157 0 0 0 0.2 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_14263_67042" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_14263_67042" result="shape" />
      </filter>
    </defs>
  </svg>
);

export default SvgComponent;
